import { compose, hoistStatics, withHandlers, lifecycle, withProps, defaultProps, withState } from 'recompose';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import Item from './Item';
import fh from '../../../helpers/form.helper';
import ModelService from '../../../services/company.service';
import AnimationsListService from '../../../services/animationsList.service';
import CardLoading from '../../../components/CardLoading';
import WithLoading from '../../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../../reducers/upload';
import LicenseService from '../../../services/license.service';
import VideoService from '../../../services/video.service';
import CompanyService from '../../../services/company.service';

const imageSelector = uploadSelectors.getTempFile('logo');

const mapStateToProps = state => ({
  logo: imageSelector(state),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
};

const defaultFormData = {
  title: '',
};

const createApplyModel = defaultFormData2 => async (setFormData, model) => {
  if (model.disabledExportTypes) {
    model.disabledExportTypes = model.disabledExportTypes.map(videoType => ({
      value: videoType,
      label: VideoService.getTypeNameById(videoType),
    }));
  }
  await setFormData({
    ...defaultFormData2,
    ...model,
  });
};

const applyModel = createApplyModel(defaultFormData);

const onSubmit = props => redirect => async (event) => {
  const { logo, isNewModel, history, formData, t } = props;
  await fh.beforeSave(event, props, redirect);
  const { model, errors } = await ModelService.update({
    ...formData,
    logo: logo && logo.id ? logo.id : '',
    payment_type: parseInt(formData.payment_type, 10),
    payment_status: parseInt(formData.payment_status, 10),
    parent_id: formData.parent_id ? formData.parent_id.value : null,
    free_trial_expired_at: moment(formData.free_trial_expired_at).format('YYYY-MM-DD HH:mm:ss'),
  });
  if (!errors) {
    if (redirect) return history.push(ModelService.baseRoute);
    if (isNewModel) return history.push(ModelService.getUpdateUrl(model.id));
    await applyModel(props.setFormData, model);
    props.removeTempFile('logo');
    fh.notify(t);
  }
  props.setErrors(!errors ? {} : errors);
  return props.setIsSubmitting(false);
};

const onChangeCompanyInput = props => async input => {
  await props.setCompanyInput(input);
};

const searchCompany = props => async () => {
  return await CompanyService.getAll({ title: props.companyInput, companyType: 'main' })
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('companyInput', 'setCompanyInput', ''),
  withState('countries', 'setCountries', []),
  withState('searchCity', 'setSearchCity', ''),
  withState('animationsLists', 'setAnimationsLists', []),
  withState('licenseList', 'setLicenseList', []),
  defaultProps({
    getImage: ModelService.getImage,
  }),
  ...fh.defaultRecompose(defaultFormData),
  lifecycle({
    async componentDidMount() {
      await fh.initModelData(this.props, applyModel, ModelService);
      window.recaptchaOptions = {
        lang: this.props.i18n.language,
      };

      const animationsLists = await AnimationsListService.getAll();
      await this.props.setAnimationsLists(animationsLists);
      this.props.setLicenseList(await LicenseService.getAll());
    },
  }),
  withProps(props => ({
    title: props.t('Company') + fh.getTitleEnd(props),
    imageSrc: props.logo && props.logo.url
      ? props.logo.url : ModelService.getImage(props.formData.logo, 150, 150),
    paymentStatusList: ModelService.getPaymentStatusOptions(props.t),
    paymentTypesList: ModelService.getPaymentTypesOptions(props.t),
    licenceTimeTypes: ModelService.getPaymentPeriodTypesOptions(props.t),
  })),
  withHandlers({
    onSubmit,
    onChange: fh.onChangeFormDataElement,
    onChangeMl: fh.onChangeFormDataMlElement,
    onChangeCompanyInput,
    searchCompany,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Item, CardLoading)));



// WEBPACK FOOTER //
// ./src/views/companies/item/index.js